import { CSSProperties, FC, ReactNode } from 'react';
import { Tabs, TabsProps } from 'antd';

import { useAntDesignTheme } from '@/hooks/useAntDesignTheme';
import { ENTITY_DETAIL_TAB_BAR_HORIZONTAL_PADDING } from '@/shared/components/layouts/tabs';

interface SearchEntityDetailContentProps {
    activeKey: string;
    children: ReactNode;
    contentStyle?: CSSProperties;
    items: NonNullable<TabsProps['items']>;
    onChange: (key: string) => void;
    tabBarExtraContent?: TabsProps['tabBarExtraContent'];
}

const SearchEntityDetailContent: FC<SearchEntityDetailContentProps> = ({
    activeKey,
    children,
    contentStyle,
    items,
    onChange,
    tabBarExtraContent,
}) => {
    const { token } = useAntDesignTheme();

    return (
        <div
            style={{
                boxSizing: 'border-box',
                display: 'flex',
                flex: '1 1 0%',
                flexDirection: 'column',
                minHeight: 0,
                overflow: 'hidden',
            }}
        >
            <div
                style={{
                    background: token.colorBgContainer,
                    flex: 'none',
                    position: 'sticky',
                    top: 0,
                    zIndex: token.zIndexBase + 1,
                }}
            >
                <Tabs
                    activeKey={activeKey}
                    items={items}
                    onChange={onChange}
                    size='small'
                    tabBarExtraContent={tabBarExtraContent}
                    tabBarStyle={{
                        background: token.colorBgContainer,
                        marginBottom: 0,
                        padding: `0 ${ENTITY_DETAIL_TAB_BAR_HORIZONTAL_PADDING}`,
                    }}
                />
            </div>
            <div
                style={{
                    boxSizing: 'border-box',
                    flex: 1,
                    minHeight: 0,
                    overflow: 'auto',
                    padding: '1.5rem',
                    ...contentStyle,
                }}
            >
                {children}
            </div>
        </div>
    );
};

export default SearchEntityDetailContent;
